import React, { useEffect } from 'react';
import AOS from 'aos';

function Notices() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const noticesData = [
    { id: 1, description: 'Notice - 03/07/2026', fileUrl: 'assets/pdf/public-notice.pdf' },
    { id: 2, description: 'Notice - 17/07/2026', fileUrl: 'assets/pdf/public-notice-17072026.pdf' },
  ];

  return (
    <>
      {/* BAnner */}
      <section className="page-header bg--cover" style={{ backgroundImage: "url(assets/images/header/1.png)" }}>
        <div className="container">
          <div className="page-header__content" data-aos="fade-right" data-aos-duration="1000">
            <h2 className="text-uppercase">Notices</h2>
            <nav style={{ "--bs-breadcrumb-divider": "'/'" }} aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item text-uppercase"><a href="/">Home</a></li>
                <li className="breadcrumb-item text-uppercase active" aria-current="page">Notices</li>
              </ol>
            </nav>
          </div>
          <div className="page-header__shape">
            <span className="page-header__shape-item page-header__shape-item--1">
              <img src="assets/images/header/2.png" alt="shape-icon" />
            </span>
          </div>
        </div>
      </section>

      <div className="container" style={{ paddingTop: '50px', paddingBottom: '50px' }} data-aos="fade-up">
        <h2 className="text-center mb-3">Notices</h2>
        <div className="table-responsive">
          <table className="table table-bordered text-center align-middle" style={{ border: '1px solid #dee2e6' }}>
            <thead style={{ backgroundColor: '#fff' }}>
              <tr>
                <th scope="col" style={{ width: '10%', padding: '15px', color: '#000', fontWeight: 'bold' }}>S. No.</th>
                <th scope="col" style={{ width: '60%', padding: '15px', color: '#000', fontWeight: 'bold' }}>Description</th>
                <th scope="col" style={{ width: '30%', padding: '15px', color: '#000', fontWeight: 'bold' }}>File</th>
              </tr>
            </thead>
            <tbody>
              {noticesData.map((notice, index) => (
                <tr key={notice.id}>
                  <td style={{ padding: '10px' }}>{index + 1}</td>
                  <td style={{ padding: '10px' }}>{notice.description}</td>
                  <td style={{ padding: '10px' }}>
                    <a href={notice.fileUrl} className="btn" target="_blank" rel="noopener noreferrer" style={{ backgroundColor: '#a6bd91', color: '#fff', padding: '6px 20px', borderRadius: '4px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', border: 'none' }}>
                      Download
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down ms-2" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" />
                      </svg>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Notices;
